module.exports = __webpack_public_path__ + "static/img/pic22.10ba335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic22.png
// module id = A6GN
// module chunks = 1